import type { IMissionCard } from 'api/cms/missions';
import { BonusStage } from 'api/common';
import type { TMissionsProgressResponse } from 'api/missions';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMissionInfo } from './useMissionInfo';
import { useNotificationState } from './useNotificationState';

export const useMissionButtonText = (
  mission: IMissionCard,
  progress?: TMissionsProgressResponse
) => {
  const { t } = useTranslation('missions');
  const missionInfo = useMissionInfo(mission, progress);
  const { button } = useNotificationState(mission, progress);

  const { button1Text, button2Text } = mission;
  const { isMissionDone, bonusStage } = missionInfo;

  const buttonText = useMemo(() => {
    if (!isMissionDone) return button1Text;
    if (button?.action === 'close') return t('ok');
    if (
      bonusStage === BonusStage.Activated ||
      bonusStage === BonusStage.HandleBets
    )
      return t('button.activated');
    return button2Text;
  }, [isMissionDone, button1Text, button?.action, t, bonusStage, button2Text]);

  return {
    buttonText,
  };
};
